module.exports = __webpack_public_path__ + "img/icon_photo_outlined.52764ef8.svg";